import { Store, select } from '@ngrx/store';
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import { AppState } from '../../reducers';
import {
  selectInsurancesInStore,
  selectInsurancesPageLoading,
  selectInsurancesShowInitWaitingMessage,
} from '../_selectors/insurance.selectors';

export class InsurancesDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectInsurancesPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(select(selectInsurancesShowInitWaitingMessage));

    this.store.pipe(select(selectInsurancesInStore)).subscribe((response: QueryResultsModel) => {
      this.paginatorTotalSubject.next(response.totalCount);
      this.entitySubject.next(response.items);
    });
  }
}
